<template>
  <div class="space-y-16">
    <div class="min-h-52">
      <slot />
    </div>

    <div
      class="flex flex-col-reverse sm:flex-row items-stretch sm:items-center gap-4 justify-between min-h-12"
    >
      <slot name="actions" />
    </div>
  </div>
</template>
